/**
 * Generates a SHA-256 hash of the input data
 * @param data Any data that can be stringified
 * @returns A hex string representation of the hash
 * @throws Error if hash generation fails
 */
export async function generateHash(data) {
  try {
    const stringified = JSON.stringify(data);
    const blob = new Blob([stringified]);
    const buffer = await crypto.subtle.digest('SHA-256', await blob.arrayBuffer());
    return Array.from(new Uint8Array(buffer)).map(b => b.toString(16).padStart(2, '0')).join('').slice(0, 6); // Reduced from 8 to 6 characters for better efficiency
  } catch (error) {
    throw new Error('Failed to generate hash');
  }
}